export function normalizeRoute(segment: string) {
  if (segment) {
    const contentWithoutLeadingSlash = segment.replace(/^\/+/, '');

    const endsWithSlash = contentWithoutLeadingSlash.endsWith('/');

    const segmentsNormalized = contentWithoutLeadingSlash
      .split('/')
      .filter(Boolean)
      .map((seg) =>
        seg
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '')
      )
      .join('/');

    return endsWithSlash && segmentsNormalized ? `${segmentsNormalized}/` : segmentsNormalized;
  }

  return '';
}

export function locationPageSlug(city: {
  slug: string;
  state?: string | null;
  country?: string | null;
}): string {
  const isUk = ['UK', 'GB'].includes(city.country ?? '') || !city.state;
  const stateSlug = isUk
    ? 'united-kingdom'
    : (city.state ?? '')
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
  const citySlug = (city.slug ?? '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
  return `/${stateSlug}/${citySlug}`;
}

export function formatCityLabel(city: {
  name: string;
  state?: string | null;
  country?: string | null;
}): string {
  return `${city.name}${city.state ? `, ${city.state}` : city.country ? ` (${city.country})` : ''}`;
}
